import React from 'react'
import { Icon } from "@material-ui/core";
import AirbyteLogo from './airbyte.svg'

export const AirbyteIcon = () => (
    React.createElement(Icon, null
        , React.createElement('img', { src: AirbyteLogo, alt: "", height: 25, width: 25,})
    )
)